import React, { useEffect } from 'react'
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'
import FeatureSlider from '../Components/FeatureSlider'
import Aos from 'aos';
function HireTrainDepoy() {
  useEffect(() => {
          Aos.init({
            duration: 1000, // animation duration in ms
            once: true,     // animate only once
          });
        }, []);
  return (
    <>
      <div className="main-div2">
        <Navbar />
        <div className='grid lg:grid-cols-2 grid-cols-1 md:gap-0 gap-[20px] justify-between overflow-hidden items-start md:pt-[163px] pt-[100px]'>
          <div>
            <div className='flex flex-col gap-[12px] pt-[34px]'>
              <img data-aos="fade-right" src="/assets/train/h1.svg" className='relative left-[-70px] md:h-[88px] h-[70px] max-w-[473px] w-full' alt="" />
              <img data-aos="fade-right" src="/assets/train/h2.svg" className='relative left-[-70px] md:h-[88px] h-[70px] max-w-[689px] w-full' alt="" />
            </div>
            <div className='flex md:justify-center'>
            <div data-aos="flip-up" className='depoy-box'>
              <h6 className="md:max-w-[334px] max-w-[250px] mx-auto w-full tracking-[-0.5px] font-sans font-[500] md:text-[31px] text-[20px] pt-[83px] text-center md:leading-[42px] leading-[30px] text-[#FFFFFF] pb-[12px]">Hire-Train-Deploy Program Powered by GISUL</h6>
              <p className="max-w-[322px] mx-auto w-full text-center font-[400] font-sans md:text-[16px] text-[14px] md:leading-[26px] leading-[20px] text-[#FFFFFF]">GISUL is a forward-thinking skilling partner for enterprises looking to build a future-ready workforce. Our programs are designed with industry-relevance, hands-on experience, and personalized mentoring to ensure immediate deployment readiness.</p>
            </div>
            </div>
          </div>
          <div>
          <div className="flex md:justify-center">
            <img data-aos="fade-left" src="/assets/train/h5.svg" alt="" />
          </div>
            <div className="flex relative">
              <img src="/assets/train/h4.svg" className='absolute top-[37px] left-[75px]' alt="" />
              <button data-aos="flip-down" className='bg-[#FDD60D] rounded-full py-[16px] px-[72px] font-sans relative z-10 ml-[131px] font-[500] text-[40px] leading-[46px] text-[#1D1837] tracking-[-0.32px]'>Features</button>
            </div>
            <div className='pt-[54px] pb-[150px] feature-slider'>
              <div className='line'></div>
              <div className='relative z-10'>
                <FeatureSlider />
              </div>
            </div>
          </div>
        </div>

        {/* <div className="New-login">
                       <div className="New-login-left">
                         <div className="b1">
                           <h2>Have Your Own</h2>
                         </div>
                         <br />
                         <div className="b2">
                           <h2>Account With Us</h2>
                         </div>
                         <br/>
                         <br/>
                         <div className='center'>

                         <div className="LateralHirning-box">
                       <h3>Best Workforce Upskilling Program offered by Gisul</h3>
                       <p>edForce a Leading Workforce Upskilling Accelerator has been helping organizations of all stratus with seamless training Modules. The lateral training program is an exercise that designs custom-made courses for the existing Employees of the organization.
                       With Lateral Training Modules, the working professionals are imbibed and are poised to set their way on an accelerated Path Of Expertise. This Upskilling cycle works on enhancing them and turning them into a courageous Mindset to deliver and make the finest use of the materials learned.</p>
            
                    
                       </div>
                       </div>
                       
                    
                       </div>
                   
               
                       <div className="New-login-right">
                       <div className='center'>
            
                       <img src={img}/>
            </div>
            <button className='Features'>Features</button>
<br/>
<br/>
                     <div className='Features-circle-div'>
                     <div>

                     <div className='Features-circle'>
                        <h3>Cloud</h3>
                        </div>
                     </div>
                     <div>

<div className='Features-circle'>
   <h3>Cloud</h3>
   </div>
</div>
  <div>

<div className='Features-circle'>
   <h3>Cloud</h3>
   </div>
</div>
  <div>

<div className='Features-circle'>
   <h3>Cloud</h3>
   </div>
</div>
  <div>

<div className='Features-circle'>
   <h3>Cloud</h3>
   </div>
</div>
                     </div>
                       <br/>
                       <br/>
                       
                       </div>
                     </div>
            <br/>
            <br/> */}

        <Footer />
      </div>
    </>
  )
}

export default HireTrainDepoy